
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2388',
  depVersions: {
  "customer-portal-app": "static-1.2388",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.468",
  "data-fetching-client": "static-1.9692",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25451",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5615",
  "hs-test-utils": "static-1.8038",
  "hub-http": "static-1.6246",
  "hub-http-shared-msw-handlers": "static-1.10024",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18301",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11497",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6488",
  "payment-link-components": "static-1.23611",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7063",
  "quartz-core": "static-1.6282",
  "quartz-i18n": "static-1.738",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10232",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5363",
  "rich-text-lib": "static-1.19875",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18032",
  "ui-components-test-utils": "static-1.5634",
  "UIComponents": "static-3.8443",
  "foundations-assets": "static-1.4893",
  "foundations-components": "static-1.7984",
  "foundations-theming": "static-1.4445",
  "foundations-theming-specialty": "static-1.2161",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.936",
  "quartz-config": "static-1.841",
  "quartz-routing": "static-1.493",
  "quick-fetch": "static-1.3935",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16696",
  "rpc-client-utils": "static-1.4677",
  "sanitize-text": "static-1.8167",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4788",
  "ui-addon-react-router-dom": "static-1.9567",
  "usage-tracker": "static-1.7373",
  "usage-tracker-anonymous": "static-1.5790",
  "usage-tracker-core": "static-1.7223",
  "video-components-external": "static-1.11357",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3417",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3340",
  "quartz-webpack": "static-1.3287",
  "bend-plugin-quartz-routing": "static-1.141",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7698",
  "frontend-preferences-client": "static-1.7952",
  "laboratory-lib": "static-3.7180",
  "onboarding-scopes": "static-1.6486",
  "seat-types-lib": "static-1.68",
  "ui-addon-opt": "static-4.8389",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3149",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.99",
  "ts-schema": "static-1.4099",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7788",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9851",
  "HubStyle": "static-2.11804",
  "knowledge-content-types": "static-1.8497",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9913",
  "ui-addon-i18n": "static-1.11173",
  "ui-business-units-lib": "static-1.9080",
  "ui-shepherd-react": "static-3.10195",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4352",
  "commerce-tours-lib": "static-1.6148",
  "customer-data-properties": "static-1.51653",
  "getting-started-shared-tasks": "static-1.18521",
  "growth-onboarding-reliability": "static-1.5107",
  "onboarding-tours": "static-1.16659",
  "reference-resolvers-lite": "static-1.8119",
  "sales-checkout-service-client": "static-1.3666",
  "ui-addon-iframeable": "static-1.9085",
  "user-context": "static-1.5130",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4670",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.738",
  "quartz-head": "static-1.728",
  "quartz-test": "static-1.738",
  "quartz-tracking": "static-1.442",
  "ui-fonts": "static-1.759",
  "usage-tracker-container": "static-1.7363",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9449",
  "data-token-picker": "static-1.16448",
  "FileManagerLib": "static-1.39330",
  "property-translator": "static-1.5424",
  "atom": "static-1.5098",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5964",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5467",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4253",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2025",
  "bend-plugin-foundations-theming": "static-1.2928",
  "foundations-theming-base": "static-1.3430",
  "stylex": "static-1.33",
  "interframe": "static-3.4784",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5787",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.87",
  "chirp-fetch": "static-1.1912",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4501",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4677",
  "content-media-composition-data-lib": "static-1.12400",
  "content-media-compositions": "static-2.16407",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4178",
  "magpie-lib": "static-1.5567",
  "magpie-types": "static-1.5027",
  "media-bridge-lib": "static-1.18967",
  "video-data-lib": "static-1.35015",
  "bender-build-tools": "static-1.3215",
  "inbound-db-properties-service-client": "static-1.3865",
  "superstore": "static-1.4786",
  "feedback-loader": "static-1.29339",
  "ai-components-ui-library": "static-1.9035",
  "ui-addon-video-player": "static-1.8727",
  "ui-coaching-tips": "static-1.28631",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4639",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2523",
  "navigation-messaging": "static-1.7437",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8195",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9657",
  "crm-message-bus": "static-1.43040",
  "growth-data-modal": "static-1.5465",
  "hubspot-apollo-client": "static-1.4904",
  "onboarding-tours-client": "static-1.4873",
  "calling-global-api": "static-1.64598",
  "calling-internal-common": "static-1.31327",
  "calling-lifecycle-internal": "static-1.65980",
  "calling-lifecycle-messages": "static-1.58274",
  "conditional-properties-service-client": "static-1.3816",
  "crm-links": "static-1.6319",
  "customer-data-objects-ui-components": "static-1.13053",
  "customer-data-properties-shared-msw-handlers": "static-1.9351",
  "customer-data-property-utils": "static-1.8115",
  "external-options-client-types": "static-1.4178",
  "file-manager-components": "static-1.23690",
  "framework-data-schema-resolvers": "static-1.6909",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.178",
  "inbound-db-meta-service-client": "static-1.3605",
  "inbounddb-objects-service-types": "static-1.4242",
  "meetings-icalendar-utils-lib": "static-1.657",
  "multi-currency-client-types": "static-1.3710",
  "object-builder-ui-client": "static-1.48828",
  "pipeline-validation-client-types": "static-1.3984",
  "property-value-citations": "static-1.2267",
  "pulse": "static-1.602",
  "smart-property-lib": "static-1.7212",
  "tiered-pricing": "static-1.1272",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11015",
  "growth-onboarding-confetti": "static-1.3091",
  "growth-onboarding-next-action-utils": "static-1.1991",
  "navigation-components": "static-1.18110",
  "onboarding-tours-utils": "static-1.725",
  "ui-shepherd-tracker": "static-1.7576",
  "ui-universal-auth": "static-1.9007",
  "batch-promise": "static-1.1566",
  "getting-started-shared-tasks-store": "static-1.17639",
  "hubspotter-http-shared-msw-handlers": "static-1.10022",
  "usage-tracker-session-replay": "static-1.5059",
  "audio-components": "static-1.5951",
  "FileManagerCore": "static-1.39189",
  "FileManagerImages": "static-1.36841",
  "video-components": "static-1.13360",
  "foundations-components-legacy": "static-1.1009",
  "purchase-motions-api": "static-1.5967",
  "signup-constants": "static-1.18888",
  "signup-ui-url-generator": "static-2.8077",
  "usage-tracker-public": "static-1.7184",
  "reactive-lib": "static-1.748",
  "simple-logging-lib": "static-1.3075",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68439",
  "copilot-toolkit": "static-1.11198",
  "growth-onboarding-feedback-components": "static-1.6605",
  "commerce-permissions": "static-1.794",
  "customer-data-tracking": "static-1.6915",
  "products-iframe-lib": "static-1.8006",
  "products-ui-components-shared-msw-handlers": "static-1.10406",
  "restore-request-side-panel-lib": "static-1.952",
  "onboarding-data-sync-lib": "static-1.1994",
  "hubspot-apollo-cache": "static-1.363",
  "calling-error-reporting": "static-1.31334",
  "shared-worker-versioning": "static-1.11062",
  "calling-usage-tracker": "static-1.6566",
  "self-service-api": "static-1.10272",
  "voice-sms-access-library": "static-1.1084",
  "conversations-skeleton-state": "static-1.7272",
  "location-customization-utils-lib": "static-1.9337",
  "crm-pipelines-api-client-types": "static-1.4158",
  "fdsr-migration-layer": "static-1.28",
  "framework-builder-read-service-client": "static-1.4024",
  "framework-data-schema-quick-fetch": "static-1.6814",
  "persist-promise": "static-1.3723",
  "bend-plugin-pulse": "static-1.105",
  "directed-graph": "static-1.960",
  "event-emitter": "static-1.972",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.232",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10107",
  "fsm": "static-1.3757",
  "policy-lib": "static-1.6802",
  "react-tinymce": "static-1.55314",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10170",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54440",
  "tinymce-plugins": "static-1.57554",
  "tinymce-themes": "static-1.56410",
  "growth-onboarding-next-action-components": "static-1.2019",
  "user-context-client": "static-1.4637",
  "nest": "static-1.254",
  "unified-auth-core-lib": "static-1.803",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4561",
  "video-embed": "static-1.35849",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22184",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4837",
  "integrations-lib": "static-1.16236",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4284",
  "InboxConnectUtils": "static-4.14884",
  "meetings-connect-utils-lib": "static-1.7630",
  "calling-orchestration-schema": "static-1.35861",
  "crm-record-cards-service-types": "static-1.3615",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4540",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3067",
  "tinymce-data": "static-1.40525",
  "ui-addon-sales-email": "static-1.5235",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12491",
  "layout-dnd-utils": "static-1.11466",
  "react-codemirror": "static-1.10651",
  "ui-brand-identity-lib": "static-1.15383",
  "NamespacedHubStyle": "static-2.9077",
  "outpost": "static-1.4204",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13651",
  "integrations-tracking-lib": "static-1.5626",
  "native-integrations-shared-strings": "static-1.7806",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10391",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.521",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68514",
  "layout-data-lib": "static-1.9791",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3038",
  "google-sheets-integration-lib": "static-1.313",
  "microsoft-drive-integration-lib": "static-1.444",
  "slack-ui-library": "static-1.10417",
  "advanced-menus-core": "static-1.15165",
  "advanced-menus-lib": "static-1.12103",
  "ExportDialog": "static-6.10408",
  "ui-memberships-settings-lib": "static-1.34116",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15164",
  "simple-menus-lib": "static-1.16681"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2388",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.468",
  "data-fetching-client": "/data-fetching-client/static-1.9692",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25451",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5615",
  "hs-test-utils": "/hs-test-utils/static-1.8038",
  "hub-http": "/hub-http/static-1.6246",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10024",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18301",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11497",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6488",
  "payment-link-components": "/payment-link-components/static-1.23611",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7063",
  "quartz-core": "/quartz-core/static-1.6282",
  "quartz-i18n": "/quartz-i18n/static-1.738",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10232",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5363",
  "rich-text-lib": "/rich-text-lib/static-1.19875",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18032",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5634",
  "UIComponents": "/UIComponents/static-3.8443",
  "foundations-assets": "/foundations-assets/static-1.4893",
  "foundations-components": "/foundations-components/static-1.7984",
  "foundations-theming": "/foundations-theming/static-1.4445",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2161",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.936",
  "quartz-config": "/quartz-config/static-1.841",
  "quartz-routing": "/quartz-routing/static-1.493",
  "quick-fetch": "/quick-fetch/static-1.3935",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16696",
  "rpc-client-utils": "/rpc-client-utils/static-1.4677",
  "sanitize-text": "/sanitize-text/static-1.8167",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4788",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9567",
  "usage-tracker": "/usage-tracker/static-1.7373",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5790",
  "usage-tracker-core": "/usage-tracker-core/static-1.7223",
  "video-components-external": "/video-components-external/static-1.11357",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3417",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3340",
  "quartz-webpack": "/quartz-webpack/static-1.3287",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.141",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7698",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7952",
  "laboratory-lib": "/laboratory-lib/static-3.7180",
  "onboarding-scopes": "/onboarding-scopes/static-1.6486",
  "seat-types-lib": "/seat-types-lib/static-1.68",
  "ui-addon-opt": "/ui-addon-opt/static-4.8389",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3149",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.99",
  "ts-schema": "/ts-schema/static-1.4099",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7788",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9851",
  "HubStyle": "/HubStyle/static-2.11804",
  "knowledge-content-types": "/knowledge-content-types/static-1.8497",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9913",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11173",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9080",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10195",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4352",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6148",
  "customer-data-properties": "/customer-data-properties/static-1.51653",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18521",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5107",
  "onboarding-tours": "/onboarding-tours/static-1.16659",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8119",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3666",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9085",
  "user-context": "/user-context/static-1.5130",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4670",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.738",
  "quartz-head": "/quartz-head/static-1.728",
  "quartz-test": "/quartz-test/static-1.738",
  "quartz-tracking": "/quartz-tracking/static-1.442",
  "ui-fonts": "/ui-fonts/static-1.759",
  "usage-tracker-container": "/usage-tracker-container/static-1.7363",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9449",
  "data-token-picker": "/data-token-picker/static-1.16448",
  "FileManagerLib": "/FileManagerLib/static-1.39330",
  "property-translator": "/property-translator/static-1.5424",
  "atom": "/atom/static-1.5098",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5964",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5467",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4253",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2025",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2928",
  "foundations-theming-base": "/foundations-theming-base/static-1.3430",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4784",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5787",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.87",
  "chirp-fetch": "/chirp-fetch/static-1.1912",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4501",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4677",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12400",
  "content-media-compositions": "/content-media-compositions/static-2.16407",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4178",
  "magpie-lib": "/magpie-lib/static-1.5567",
  "magpie-types": "/magpie-types/static-1.5027",
  "media-bridge-lib": "/media-bridge-lib/static-1.18967",
  "video-data-lib": "/video-data-lib/static-1.35015",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3865",
  "superstore": "/superstore/static-1.4786",
  "feedback-loader": "/feedback-loader/static-1.29339",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8727",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28631",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4639",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2523",
  "navigation-messaging": "/navigation-messaging/static-1.7437",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8195",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9657",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "growth-data-modal": "/growth-data-modal/static-1.5465",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4904",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4873",
  "calling-global-api": "/calling-global-api/static-1.64598",
  "calling-internal-common": "/calling-internal-common/static-1.31327",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65980",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58274",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3816",
  "crm-links": "/crm-links/static-1.6319",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13053",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9351",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8115",
  "external-options-client-types": "/external-options-client-types/static-1.4178",
  "file-manager-components": "/file-manager-components/static-1.23690",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6909",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.178",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3605",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4242",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.657",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3710",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48828",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3984",
  "property-value-citations": "/property-value-citations/static-1.2267",
  "pulse": "/pulse/static-1.602",
  "smart-property-lib": "/smart-property-lib/static-1.7212",
  "tiered-pricing": "/tiered-pricing/static-1.1272",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11015",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3091",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1991",
  "navigation-components": "/navigation-components/static-1.18110",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.725",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7576",
  "ui-universal-auth": "/ui-universal-auth/static-1.9007",
  "batch-promise": "/batch-promise/static-1.1566",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17639",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10022",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5059",
  "audio-components": "/audio-components/static-1.5951",
  "FileManagerCore": "/FileManagerCore/static-1.39189",
  "FileManagerImages": "/FileManagerImages/static-1.36841",
  "video-components": "/video-components/static-1.13360",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1009",
  "purchase-motions-api": "/purchase-motions-api/static-1.5967",
  "signup-constants": "/signup-constants/static-1.18888",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8077",
  "usage-tracker-public": "/usage-tracker-public/static-1.7184",
  "reactive-lib": "/reactive-lib/static-1.748",
  "simple-logging-lib": "/simple-logging-lib/static-1.3075",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68439",
  "copilot-toolkit": "/copilot-toolkit/static-1.11198",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6605",
  "commerce-permissions": "/commerce-permissions/static-1.794",
  "customer-data-tracking": "/customer-data-tracking/static-1.6915",
  "products-iframe-lib": "/products-iframe-lib/static-1.8006",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10406",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.952",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1994",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.363",
  "calling-error-reporting": "/calling-error-reporting/static-1.31334",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11062",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6566",
  "self-service-api": "/self-service-api/static-1.10272",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1084",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7272",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9337",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4158",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.28",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4024",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6814",
  "persist-promise": "/persist-promise/static-1.3723",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.105",
  "directed-graph": "/directed-graph/static-1.960",
  "event-emitter": "/event-emitter/static-1.972",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.232",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10107",
  "fsm": "/fsm/static-1.3757",
  "policy-lib": "/policy-lib/static-1.6802",
  "react-tinymce": "/react-tinymce/static-1.55314",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10170",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54440",
  "tinymce-plugins": "/tinymce-plugins/static-1.57554",
  "tinymce-themes": "/tinymce-themes/static-1.56410",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2019",
  "user-context-client": "/user-context-client/static-1.4637",
  "nest": "/nest/static-1.254",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.803",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4561",
  "video-embed": "/video-embed/static-1.35849",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22184",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4837",
  "integrations-lib": "/integrations-lib/static-1.16236",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4284",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14884",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7630",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35861",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4540",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3067",
  "tinymce-data": "/tinymce-data/static-1.40525",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5235",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12491",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11466",
  "react-codemirror": "/react-codemirror/static-1.10651",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15383",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9077",
  "outpost": "/outpost/static-1.4204",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13651",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5626",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7806",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10391",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.521",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68514",
  "layout-data-lib": "/layout-data-lib/static-1.9791",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3038",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.313",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
  "slack-ui-library": "/slack-ui-library/static-1.10417",
  "advanced-menus-core": "/advanced-menus-core/static-1.15165",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12103",
  "ExportDialog": "/ExportDialog/static-6.10408",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34116",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15164",
  "simple-menus-lib": "/simple-menus-lib/static-1.16681"
}
};
